import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'

const EmailUpdateUI = ({context, messageList,
  email, onEmailChange, emailError, setEmailError,
  // form
  onSubmit, submitted, successMsg, errorList, errorCode, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_update'
      onSubmit={onSubmit} busy={submitted}
      successMsg={successMsg} errorList={errorList} errorCode={errorCode} setErrorList={setErrorList}
    >
      <InputTextSF type='text' name='email' required={true} maxLength={40}
        messageList={messageList} labelKey='c_email'
        value={email} onChange={onEmailChange}
        error={emailError} setError={setEmailError}
        autoFocus={true}
      />
    </FormSF>
  </CardUI>

export default EmailUpdateUI
